import { ADD_CLIENT } from "../../CONSTANTS";

export default function addClient({
  remoteId,
  type,
  data = {},
  select = true,
}) {
  return {
    type: ADD_CLIENT,
    payload: {
      remoteId,
      type,
      data,
      select,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/clients/addClient.js